import { render } from "./SignaturePad.vue?vue&type=template&id=b884d68e&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"

import "./SignaturePad.vue?vue&type=style&index=0&id=b884d68e&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b884d68e"]])

export default __exports__